<template>
  <div v-cdn="'BACKGROUND_IMAGE'" class="app-background">
    <otp-modal
      v-if="receiveOtpOn && showOtpModal"
      :show-otp-modal="showOtpModal"
      @close-otp-modal="onCloseOtpModal"
    />
    <mfa-method-selection-modal
      v-else
      :is-mfa-selection-modal-visible="showOtpModal"
      :is-user-logging-in="true"
      @close-mfa-selection-modal="onCloseOtpModal"
    />
    <div v-if="!isTokenSet || isSigningIn" class="auth-form">
      <img crossorigin="anonymous" alt="logo" class="logo" :src="ASSETS.KCP_FULL_LOGO" />
      <h3 class="heading">Sign in</h3>
      <a-form
        layout="vertical"
        :model="form"
        :rules="rules"
        name="login"
        class="user-form"
        @finish="onSubmit"
      >
        <a-form-item name="email" autocomplete="off">
          <a-input v-model:value="form.email" placeholder="Enter email" />
        </a-form-item>

        <a-form-item name="password" autocomplete="off">
          <a-input-password v-model:value="form.password" placeholder="Password" />
        </a-form-item>

        <div>
          <div class="signin-btn">
            <a-button type="primary" size="large" block html-type="submit" :loading="isSigningIn">
              Sign in
            </a-button>
          </div>

          <div class="middle">
            <div class="divider"></div>
            <div class="continue">OR</div>
            <div class="divider"></div>
          </div>

          <a-button block @click="AzureSignIn">
            <template #icon
              ><img crossorigin="anonymous" :src="ASSETS.MS_LOGO" alt="" class="ms-logo"
            /></template>
            <span class="fw-bold">Continue with Microsoft Account</span>
          </a-button>
        </div>

        <div class="form-link mt-5">
          <!-- <router-link to="/signup">
            <small>Don't have an account? Click here to signup</small>
          </router-link> -->
          <router-link to="/forgot-password">
            <small>Forgot Password?</small>
          </router-link>
        </div>
      </a-form>
    </div>

    <div v-else-if="linkedOrganizations.length > 1" class="auth-form">
      <img alt="logo" class="logo" :src="ASSETS.KCP_FULL_LOGO" />
      <h3 class="heading">Which organization do you want to access?</h3>
      <ul class="organization-list">
        <li
          v-for="organization in linkedOrganizations"
          :key="organization.id"
          @click="
            selectOrganization({
              organization: organization.organization
            })
          "
        >
          {{ organization.organization_description }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'pinia'
import { ASSETS } from 'src/constants/cdnConstants'
import { clearLocalStorageExcept } from 'src/config/auth-config'
import { useAuthStore } from 'src/stores/auth'
import { useToast } from 'vue-toastification'
import OtpModal from './OtpModal.vue'
import MfaMethodSelectionModal from 'src/components/Auth/MfaMethodSelectionModal.vue'

export default {
  setup() {
    const toast = useToast()
    const rules = {
      email: [
        {
          required: true,
          type: 'email',
          trigger: 'submit',
          message: 'email is required'
        }
      ],
      password: [{ required: true, trigger: 'submit', message: 'password is required' }]
    }
    return {
      toast,
      rules,
      ASSETS
    }
  },
  components: {
    MfaMethodSelectionModal,
    OtpModal
  },
  data() {
    return {
      showOtpModal: false,
      form: {
        email: '',
        password: ''
      }
    }
  },
  created() {
    this.clearState()
    this.createMsalInstance()
    window.addEventListener('beforeunload', this.clearAuthState)
  },
  beforeUnmount() {
    window.removeEventListener('beforeunload', this.clearAuthState)
  },
  computed: {
    ...mapState(useAuthStore, [
      'isTokenSet',
      'organization',
      'isSigningIn',
      'msalInstance',
      'requireOtp',
      'linkedOrganizations',
      'receiveOtpOn'
    ])
  },
  watch: {
    receiveOtpOn(value) {
      if (value === 'email' && this.requireOtp) {
        this.showOtpModal = true
      }
    },
    linkedOrganizations: {
      deep: true,
      handler() {
        this.showOtpModal = false
      }
    }
  },
  methods: {
    ...mapActions(useAuthStore, [
      'userLogin',
      'azureSignIn',
      'createMsalInstance',
      'clearState',
      'clearAllStates',
      'selectOrganization'
    ]),
    async onSubmit() {
      const payload = {
        email: this.form.email,
        password: this.form.password
      }
      const res = await this.userLogin(payload)
      if (!res) return

      if (this.requireOtp) this.showOtpModal = true
    },

    async AzureSignIn() {
      await this.msalInstance
        .loginPopup({
          scopes: ['openid', 'profile', 'User.Read', 'email'],
          prompt: 'select_account'
        })
        .then((res) => {
          const myAccounts = this.msalInstance.getAllAccounts()
          const payload = {
            access_token: res.accessToken
          }
          this.account = myAccounts[0]
          this.msalInstance.setActiveAccount(this.account)
          this.azureSignIn(payload)
        })
        .catch((error) => {
          console.error(`error during authentication: ${error}`)
          this.clearState()
          this.$router.replace({ name: 'Login' })
        })
    },

    onCloseOtpModal(shouldClearAuth) {
      this.showOtpModal = false
      if (shouldClearAuth) {
        this.clearAuthState()
      }
    },

    clearAuthState() {
      clearLocalStorageExcept()
      this.clearAllStates()
    }
  }
}
</script>

<style scoped>
.container {
  height: 100vh;
  overflow: hidden;
}

.auth-form {
  width: 450px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  border-radius: 16px;
  margin: auto;
  padding: 20px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  opacity: 0.9;
}

.logo {
  width: 240px;
  /* height: 60px; */
  margin-bottom: 10px;
}
.ms-logo {
  height: 15px;
  margin-bottom: 3px;
  margin-right: 8px;
  /* align-content: center; */
}
.signin-btn {
  margin-left: 0px;
}
.heading {
  font-size: 1.4rem;
  margin-bottom: 14px;
}
.user-form {
  width: 80%;
  margin-top: 20px;
}

.form-link {
  text-align: center;
  margin: 0px 0px 24px 0px;
}
.form-link a {
  text-decoration: none;
  font-size: 16px;
}
.form-link a:hover {
  text-decoration: underline;
}
.middle {
  box-sizing: border-box;
  margin: 0px;
  min-width: 0;
  display: flex;
  margin-top: 16px;
  margin-bottom: 16px;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  justify-content: space-between;
}
.continue {
  box-sizing: border-box;
  margin-left: 5px;
  margin-right: 5px;
  min-width: 0;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #707a8a;
}
.divider {
  box-sizing: border-box;
  margin: 0;
  min-width: 0;
  height: 1px;
  flex: 1;
  background-color: #eaecef;
}

.app-background {
  height: 100vh;
  background-size: cover;
  position: relative;
  background-position: center;
}

.app-background::before {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
}

.organization-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
  max-height: 360px;
  overflow-y: auto;
  overflow-x: hidden;
  border-radius: 8px;
  padding-right: 10px;
}

.organization-list li {
  background-color: #f0f4f8; /* Light background for list items */
  border-radius: 8px; /* Rounded corners */
  padding: 12px 20px; /* Increased padding for comfort */
  margin: 10px 0; /* Space between items */
  transition: background-color 0.3s, transform 0.2s; /* Smooth transition for hover effect */
  cursor: pointer; /* Change cursor on hover */
  font-size: 1.1rem; /* Slightly larger font for better readability */
}

.organization-list li:hover {
  background-color: #e0e7ee; /* Darker shade on hover */
  transform: scale(1.02); /* Slight scale effect on hover */
}
</style>
